module.exports = __webpack_public_path__ + "fontawesome-webfont.fee66e712a8a08eef580";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/assets/vendors/by_hands/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = ../../../../../src/assets/vendors/by_hands/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module chunks = styles